"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _remark = _interopRequireDefault(require("remark"));

var _remarkParse = _interopRequireDefault(require("remark-parse"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var _remarkAttr = _interopRequireDefault(require("remark-attr"));

var Table = function Table(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        textAlign: 'center',
        paddingBottom: '1.5rem'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("p", {
      className: "is-size-9 has-text-weight-bold"
    }, props.title),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "".concat(props.data.isScrollable ? "table-container" : null)
    },
    /*#__PURE__*/
    _react["default"].createElement("table", {
      className: "table is-striped is-fullwidth"
    }, props.data.header &&
    /*#__PURE__*/
    _react["default"].createElement("thead", null,
    /*#__PURE__*/
    _react["default"].createElement("tr", null, props.data.header.map(function (header) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("th", {
          style: {
            backgroundColor: "".concat(header.color),
            color: "".concat(header.textColor)
          }
        }, header.cell !== null &&
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(header.cell).contents))
      );
    }))), props.data.footer &&
    /*#__PURE__*/
    _react["default"].createElement("tfoot", null,
    /*#__PURE__*/
    _react["default"].createElement("tr", null, props.data.footer.map(function (footer) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("th", {
          style: {
            backgroundColor: "".concat(footer.color),
            color: "".concat(footer.textColor)
          }
        }, footer.cell !== null &&
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(footer.cell).contents))
      );
    }))),
    /*#__PURE__*/
    _react["default"].createElement("tbody", null, props.data.rows.map(function (rows) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("tr", null, rows.row.map(function (row) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react["default"].Fragment, null, row.cell !== null &&
            /*#__PURE__*/
            _react["default"].createElement("td", {
              style: {
                backgroundColor: "".concat(row.color),
                color: "".concat(row.textColor)
              }
            }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(row.cell).contents))
          );
        }))
      );
    }))), props.note &&
    /*#__PURE__*/
    _react["default"].createElement("p", null, props.note)))
  );
};

var _default = Table;
exports["default"] = _default;